import React, { useState, Fragment, useCallback, useRef } from 'react'
import { useEventListener, useToggle, useOnClickOutside } from 'hooks'
import Searchbox from 'components/Searchbox'
import SearchbarContent from 'components/SearchbarContent'

const Index = ({
    onChange,
    onEnter,
    onClear,
    onSelectSuggestion,
    isTyping,
    data,
    min = 2,
    value,
    classes = [],
    reinitialize,
    ...props
}) => {
    const [val, setValue] = useState(value || '')
    const { isOpen, onOpen, onClose } = useToggle()
    const myRef = useRef(null)
    useOnClickOutside(myRef, onClose, 'searchBar')

    useEventListener('keydown', ({ key }) => {
        if (key === 'Enter' && val.trim() !== '') {
            handleSubmit()
        }
    })

    const handleChange = useCallback(v => {
        if (v.length === 0 && onClear) onClear()
        if (v && v.length > 2) onOpen()
        else onClose()
        onChange(v)
        setValue(v)
    }, [])

    const handleClear = useCallback(async () => {
        await setValue('')
        await onClose()
        onChange('')
        onClear && onClear()
    }, [])

    const handleSelectSuggestion = val => {
        onClose()
        onSelectSuggestion(val)

        if (reinitialize) {
            setValue('')
        } else {
            setValue(val.keyword)
        }
    }

    const handleSubmit = () => {
        if (val.trim() !== '') {
            onClose()
            onEnter(val.trim())
            if (reinitialize) {
                setValue('')
            }
        }
    }

    return (
        <Fragment>
            <Searchbox
                onChange={handleChange}
                onClear={handleClear}
                isTyping={isTyping}
                value={val}
                onClick={handleSubmit}
                {...props}
            />
            {isOpen && (
                <SearchbarContent
                    ref={myRef}
                    isLoading={isTyping}
                    data={data}
                    onSelect={handleSelectSuggestion}
                    dataKeys={props.dataKeys}
                    classes={classes}
                />
            )}
        </Fragment>
    )
}

export default React.memo(Index)
